import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { PaisProvider } from './context/PaisContext';
import { AseguradoraProvider } from './context/AseguradoraContext';
import { IdiomaProvider } from './context/IdiomaContext';
import reportWebVitals from './reportWebVitals';

ReactDOM.render(

    <IdiomaProvider>
      <PaisProvider>
        <AseguradoraProvider>
          <App />
        </AseguradoraProvider>
      </PaisProvider>
    </IdiomaProvider>
  ,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(//console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
